import React from "react";

interface IconProps {
  fill: string;
}

const HomeIcon = ({ fill }: IconProps) => (
  <svg
    width="3.5rem"
    height="3.5rem"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.4371 5.54781C11.8804 5.19322 12.4314 5 12.9993 5C13.5672 5 14.1182 5.19322 14.5614 5.54781L22.0614 11.5397C22.6543 12.0133 23 12.7309 23 13.4899V23.5034C23 24.1655 22.7366 24.8006 22.2678 25.2688C21.7989 25.737 21.163 26 20.5 26H15.5C15.2158 26 14.9433 25.8873 14.7424 25.6866C14.5415 25.486 14.4286 25.2138 14.4286 24.93V17.4402H11.5714V24.93C11.5714 25.2138 11.4585 25.486 11.2576 25.6866C11.0567 25.8873 10.7842 26 10.5 26H5.5C4.83696 26 4.20107 25.737 3.73223 25.2688C3.26339 24.8006 3 24.1655 3 23.5034V13.4884C3 12.7309 3.34571 12.0133 3.93857 11.5397L11.4371 5.54781ZM13.2229 7.21839C13.1596 7.16793 13.081 7.14044 13 7.14044C12.919 7.14044 12.8404 7.16793 12.7771 7.21839L5.27714 13.2102C5.23513 13.2438 5.20123 13.2863 5.17798 13.3347C5.15472 13.3831 5.14272 13.4362 5.14286 13.4899V23.5034C5.14286 23.7003 5.30286 23.8601 5.5 23.8601H9.42857V16.3702C9.42857 16.0865 9.54145 15.8143 9.74239 15.6137C9.94332 15.413 10.2158 15.3003 10.5 15.3003H15.5C15.7842 15.3003 16.0567 15.413 16.2576 15.6137C16.4585 15.8143 16.5714 16.0865 16.5714 16.3702V23.8601H20.5C20.5947 23.8601 20.6856 23.8225 20.7525 23.7556C20.8195 23.6887 20.8571 23.598 20.8571 23.5034V13.4884C20.8571 13.435 20.845 13.3822 20.8217 13.3341C20.7985 13.2859 20.7647 13.2436 20.7229 13.2102L13.2229 7.21839Z"
      fill={fill}
    />
  </svg>
);

export default HomeIcon;
